// Styled Components
import styled from "styled-components";

// Material UI
// import Button from "@mui/material/Button";
import { Button } from "@material-ui/core";

const GenerateText = () => {
  return (
    <Wrapper>
      <p className="header">GENERATE A COMPLETE SHOEUZI</p>
      <p className="content">
        If you have collected all the traits of a Complete shoeuzi, enter them
        here and you will be ableto mint the complete version to your wallet.
        The scattered ones you use in the process will be burnt.
      </p>
      <p className="content-red">
        Coming soon!
      </p>

      {/* <form
        className="email-wrapper"
        action="https://formsubmit.co/4b2ff49b146e551349a0c2645bbcc9f1"
        method="POST"
      >
        <input type="email" placeholder="E-Mail" name="User email" required />

        <Button variant="contained" className="button" type="submit">
          GET NOTIFIED
        </Button>
      </form> */}
    </Wrapper>
  );
};

export default GenerateText;

const Wrapper = styled.div`
  //
  width: 580px;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
  //

  z-index: 101;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0px;

  .header {
    font-family: interstate, sans-serif;
    font-weight: 900;
    font-style: normal;
    font-size: 3rem;
    padding-bottom: 30px;

    font-family: "Pixeltype";
    font-weight: 200;

    line-height: 60px;
  }

  .content {
    color: #8f8f8f;
    font-size: 1.1rem;

    width: 100%;

    line-height: 31px;

    color: #fff;
    font-family: "Open Sans", sans-serif;
    font-weight: 300;

    &-red {
      color: #8f8f8f;
      font-size: 1.1rem;

      line-height: 31px;
      font-family: acumin-pro-wide, sans-serif;
      color: red;
      padding-top: 20px;
      font-weight: 300;
    }
  }

  .email-wrapper {
    font-size: 1.1rem;
    font-weight: 700;

    border-width: 0px;
    border: none;
    outline: none;

    width: 100%;

    &:focus {
      border-width: 0px;
      border: none;
    }

    display: flex;
    justify-content: flex-start;
    align-items: center;

    padding-top: 20px;

    input {
      height: 35px;
      font-size: 1.1rem;
      font-weight: 200;
      padding-left: 10px;

      border: none;
      outline: none;
      border-radius: 0px !important;

      width: 100%;

      //
      width: 300px;
      @media only screen and (max-width: 500px) {
        width: 55%;
      }
      //
    }

    .button {
      border-radius: 0px;
      background-color: #000;
      height: 35px;
      font-size: 1.1rem;
      font-weight: 700;

      @media only screen and (max-width: 500px) {
        width: 45%;
      }
    }
  }
`;
